import script from "./InvoiceTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTab.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTab.vue?vue&type=style&index=0&id=44f54b1c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f54b1c"]])

export default __exports__